import React, { useContext, useEffect, useState } from 'react';
import { MdOutlineAddAPhoto } from 'react-icons/md';
import { RxCross2 } from 'react-icons/rx';
import Select from 'react-select';
import Style from "./Style.module.css";
import { UserContext } from '../../../../Contexts/UserContext';
import instance from '../../../../instance/AxiosInstance';
import authInstance from '../../../../instance/AuthInstance';
import { CategoryContext } from '../../../../Contexts/CategoryContext';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import LoadingSpin from "react-loading-spin";
import { useTranslation } from 'react-i18next';
import { STATES_DISTRICTS_DATA } from '../../../../utilities/statesDistrictsData'


// Get all states
const allStates = STATES_DISTRICTS_DATA.states.map(s => s.state);

// Get districts for a specific state
const getDistrictsForState = (stateName) => {
  const stateObj = STATES_DISTRICTS_DATA.states.find(
    s => s.state === stateName
  );
  return stateObj?.districts || [];
};

// Total states count
const totalStates = STATES_DISTRICTS_DATA.states.length;

// Total districts count
const totalDistricts = STATES_DISTRICTS_DATA.states.reduce(
  (acc, state) => acc + state.districts.length, 
  0
);

const AdvertisementForm = () => {
  const { t, i18n } = useTranslation();
  const Navigate = useNavigate();

  // Section navigation
  const [currentSection, setCurrentSection] = useState(1);

  const [ProductData, SetProductData] = useState({
    title: "",
    redirectionUrl: "",
    region: "india",
    advSize: "1",
  });

  const [File, SetFile] = useState([]);
  const [Error, SetError] = useState({
    imagefile: ""
  });

  const [CatSelecter, SetCatSelecter] = useState([]);
  const [loading, setLoading] = useState(false);

  // Coverage and pricing states
  const [coverageType, setCoverageType] = useState("");
  const [numDays, setNumDays] = useState("1");
  const [selectedPage, setSelectedPage] = useState("home");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [price, setPrice] = useState(0);
  const [selectedStates, setSelectedStates] = useState([]);
  const [selectedDistricts, setSelectedDistricts] = useState({});
  const [renderHomeToggle, setRenderHomeToggle] = useState(true);

  const LoggedInUser = useContext(UserContext);
  const { User } = LoggedInUser;
  const categories = useContext(CategoryContext);
  const { Categories } = categories;
  const RazorpayKey = process.env.REACT_APP_RAZORPAY_KEY;

  const sizeOptions = [
    { value: "1", label: t("1x_size") || "1x Size" },
    { value: "2", label: t("2x_size") || "2x Size" },
  ];

  const coverageTypes = [
    { value: "", label: t("select_coverage") || "Select Coverage Type" },
    { value: "national", label: t("all_india") || "All India" },
    { value: "state", label: t("state_wise") || "State Wise" },
  ];

  const pageOptions = [
    { value: "home", label: t("home_page") || "Home Page" },
    { value: "category", label: t("category_page") || "Category Page" },
  ];

  useEffect(() => {
    if (Categories?.length > 0) {
      const Cats = Categories.map((eachCategory) => ({
        value: eachCategory._id,
        label: typeof eachCategory.categoryName === "object"
          ? eachCategory.categoryName[i18n.language] || eachCategory.categoryName.en
          : eachCategory.categoryName,
      })).filter(cat => cat.label);

      SetCatSelecter(Cats);
    }
  }, [Categories, i18n.language]);

  // Price calculation
  useEffect(() => {
    calculatePrice();
  }, [coverageType, numDays, selectedStates, selectedDistricts, ProductData.advSize, renderHomeToggle, selectedPage]);

  const calculatePrice = () => {
    const stateCostPerRender = 2;
    const countryCostPerRender = 5;

    const advSize = Number(ProductData?.advSize) || 0;
    const days = parseInt(numDays) || 1;

    const totalDistricts = Object.values(selectedDistricts).reduce(
      (acc, districts) => acc + (Array.isArray(districts) ? districts.length : 0),
      0
    );

    let basePrice = 0;

    if (coverageType === "state" && totalDistricts > 0) {
      basePrice = totalDistricts * days * stateCostPerRender;
    } else if (coverageType === "national") {
      basePrice = days * countryCostPerRender;
    }

    let advSizePrice = 0;
    if (renderHomeToggle) {
      if (advSize === 1) {
        advSizePrice = coverageType === "state" ? 5 : 100;
      }
      if (advSize === 2) {
        advSizePrice = coverageType === "state" ? 10 : 200;
      }
    }

    let pageSelectionPrice = 0;
    if (!renderHomeToggle && selectedPage) {
      if (advSize === 1) {
        pageSelectionPrice = coverageType === "state" ? 3 : 50;
      }
      if (advSize === 2) {
        pageSelectionPrice = coverageType === "state" ? 5 : 80;
      }
    }

    const finalPrice = basePrice + advSizePrice + pageSelectionPrice;
    setPrice(Math.round(finalPrice));
  };

  const uploadFile = (e) => {
    const files = e.target.files;
    if (File.length < 1) {
      SetFile([...File, ...files]);
      SetError({ ...Error, imgfile: "" });
    } else {
      SetError({ ...Error, imgfile: t("image_error") || "Only 1 image allowed" });
      e.target.value = "";
    }
  };

  const toggleStateSelection = (stateName) => {
    setSelectedStates((prev) => {
      if (prev.includes(stateName)) {
        const newDistricts = { ...selectedDistricts };
        delete newDistricts[stateName];
        setSelectedDistricts(newDistricts);
        return prev.filter((name) => name !== stateName);
      } else {
        return [...prev, stateName];
      }
    });
  };

  const toggleDistrictSelection = (stateName, districtName) => {
    setSelectedDistricts((prev) => {
      const stateDistricts = prev[stateName] || [];
      if (stateDistricts.includes(districtName)) {
        return {
          ...prev,
          [stateName]: stateDistricts.filter((name) => name !== districtName),
        };
      } else {
        return {
          ...prev,
          [stateName]: [...stateDistricts, districtName],
        };
      }
    });
  };

  const validateSection1 = () => {
    if (!ProductData.title.trim()) {
      toast.error(t("enter_title") || "Please enter advertisement title");
      return false;
    }
    if (!ProductData.redirectionUrl.trim()) {
      toast.error(t("enter_url") || "Please enter redirection URL");
      return false;
    }
    if (File.length === 0) {
      toast.error(t("select_image") || "Please select an image");
      return false;
    }
    return true;
  };

  const validateSection2 = () => {
    if (!coverageType) {
      toast.error(t("select_coverage_type") || "Please select coverage type");
      return false;
    }

    if (coverageType === 'state') {
      if (selectedStates.length === 0) {
        toast.error(t("select_state") || "Please select at least one state");
        return false;
      }

      const totalDistricts = Object.values(selectedDistricts).reduce(
        (acc, curr) => acc + (curr?.length || 0),
        0
      );

      if (totalDistricts === 0) {
        toast.error(t("select_district") || "Please select at least one district");
        return false;
      }
    }

    if (!numDays || parseInt(numDays) < 1) {
      toast.error(t("enter_days") || "Please enter valid number of days");
      return false;
    }

    if (!renderHomeToggle && selectedPage === 'category' && !selectedCategory) {
      toast.error(t("select_category") || "Please select a category");
      return false;
    }

    return true;
  };

  const handleNext = () => {
    if (currentSection === 1 && validateSection1()) {
      setCurrentSection(2);
    } else if (currentSection === 2 && validateSection2()) {
      setCurrentSection(3);
    }
  };

  const handleBack = () => {
    if (currentSection > 1) setCurrentSection(currentSection - 1);
  };

  const handlePayment = async () => {
    try {
      setLoading(true);

      const orderResponse = await fetch("https://api.dealnbuy.in/api/payment/create-order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: price * 100 }),
      });

      const orderData = await orderResponse.json();
      console.log("Order ID received:", orderData.orderId);

      if (!orderResponse.ok) {
        toast.error("Order creation failed!");
        setLoading(false);
        return;
      }

      const options = {
        key: RazorpayKey,
        amount: price * 100,
        currency: "INR",
        name: "DealnBuy",
        description: "Advertisement Payment",
        order_id: orderData.orderId,
        handler: async function (response) {
          console.log("Payment Successful:", response);

          const verifyResponse = await fetch("https://api.dealnbuy.in/api/payment/verify-payment", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              orderId: orderData.orderId,
              paymentId: response.razorpay_payment_id,
              signature: response.razorpay_signature,
            }),
          });

          const verifyData = await verifyResponse.json();

          if (verifyResponse.ok && verifyData.success) {
            handleSubmit(response, orderData.orderId);
          } else {
            toast.error("Payment verification failed!");
            setLoading(false);
          }
        },
        prefill: {
          name: User?.fullname || "User",
          email: User?.email || "noemail@example.com",
          contact: User?.phoneNumber || "0000000000",
        },
        theme: { color: "#3399cc" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      
      rzp.on('payment.failed', function (response) {
        console.error('Payment Failed:', response.error);
        toast.error("Payment failed!");
        setLoading(false);
      });

    } catch (error) {
      console.error("Error in payment process:", error);
      toast.error("Payment initialization failed");
      setLoading(false);
    }
  };

  const handleSubmit = async (paymentResponse, orderId) => {
    try {
      setLoading(true);

      let data = new FormData();
      
      File.forEach((file) => {
        data.append("files", file);
      });

      const formattedCoverageData = {
        type: coverageType || "",
        states: selectedStates || [],
        districts: selectedDistricts || {}
      };

      data.append("title", ProductData.title?.trim() || "");
      data.append("userId", User?._id || "");
      data.append("region", "india");
      data.append("featured", User?.premiumuser || false);
      data.append("redirectionUrl", ProductData.redirectionUrl || "");
      data.append("advSize", Number(ProductData.advSize) || 1);
      data.append('coverageData', JSON.stringify(formattedCoverageData));
      data.append('coverageType', coverageType || "");
      data.append('numDays', Number(numDays) || 1);
      data.append('selectedPage', renderHomeToggle ? "home" : selectedPage || "");
      data.append('category', selectedCategory || null);
      data.append('subcategory', null);
      data.append("paymentResponse", JSON.stringify(paymentResponse || {}));
      data.append('orderId', orderId || "");
      data.append('email', User?.email || "");

      const response = await authInstance.post('/api/user/advertisement/add_new_adv', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      console.log("Backend Response:", response.data);
      
      setLoading(false);
      toast.success(t("ad_added_success") || "Advertisement added successfully!");
      Navigate('/');

      // Reset form
      SetProductData({
        title: "",
        redirectionUrl: "",
        region: "india",
        advSize: "1",
      });
      setNumDays("1");
      setSelectedPage("home");
      SetFile([]);
      setCoverageType("");
      setSelectedStates([]);
      setSelectedDistricts({});
      setSelectedCategory("");
      setCurrentSection(1);

    } catch (err) {
      setLoading(false);
      console.error("Submit Error:", err.response?.data || err.message);
      toast.error(t("submit_failed") || `Failed to submit: ${err.response?.data?.message || err.message}`);
    }
  };

  const getCategoryName = (categoryId) => {
    const category = CatSelecter.find(cat => cat.value === categoryId);
    return category ? category.label : 'Unknown Category';
  };

  const getPageLabel = () => {
    if (renderHomeToggle) return 'Home Page';
    const page = pageOptions.find(p => p.value === selectedPage);
    return page ? page.label : selectedPage;
  };

  // Section 1: Basic Information
  const renderSection1 = () => (
    <div className={Style.section}>
      <h3 className={Style.section_title}>{t("basic_info") || "Basic Information"}</h3>

      <div className={Style.row}>
        <label>{t("title")}<span className="star">*</span></label>
        <div className={Style.items}>
          <input
            type="text"
            name="title"
            value={ProductData.title}
            onChange={(e) => SetProductData({ ...ProductData, title: e.target.value })}
            placeholder={t("enter_ad_title") || "Enter advertisement title"}
            required
          />
          <p>{t("key_features") || "Add a catchy title"}</p>
        </div>
      </div>

      <div className={Style.row}>
        <label>{t("redirection_url")}<span className="star">*</span></label>
        <div className={Style.items}>
          <input
            type="url"
            name="redirectionUrl"
            value={ProductData.redirectionUrl}
            onChange={(e) => SetProductData({ ...ProductData, redirectionUrl: e.target.value })}
            placeholder="https://example.com"
            required
          />
          <p>{t("url_hint") || "Where should users go when they click"}</p>
        </div>
      </div>

      <div className={Style.row}>
        <label>{t("advertisement_size")}<span className="star">*</span></label>
        <div>
          <Select
            options={sizeOptions}
            value={sizeOptions.find(opt => opt.value === ProductData.advSize)}
            onChange={(e) => SetProductData({ ...ProductData, advSize: e.value })}
            required
          />
        </div>
      </div>

      <div className={Style.row}>
        <label>{t("images")}<span className="star">*</span></label>
        <div className={Style.image_wrapper}>
          <label htmlFor="file-input">
            <MdOutlineAddAPhoto />
          </label>
          <input
            type="file"
            onChange={(e) => uploadFile(e)}
            id="file-input"
            accept="image/*"
            required
          />
          {File.map((eachImage, index) => (
            <div key={index} className={Style.image_sec}>
              <img
                src={eachImage ? URL.createObjectURL(eachImage) : null}
                alt={`preview ${index}`}
              />
              <div className={Style.clearbtn}>
                <button type="button" onClick={() => SetFile([])}>
                  <RxCross2 />
                </button>
              </div>
            </div>
          ))}
        </div>
        <div>
          <span style={{ color: "red", fontSize: "14px" }}>
            {Error?.imagefile}
          </span>
        </div>
        <div>
          <p>{t("upload_image") || "Upload a clear image (Max 5MB, JPG/PNG)"}</p>
        </div>
      </div>
    </div>
  );

  // Section 2: Plan Details
  const renderSection2 = () => (
    <div className={Style.section}>
      <h3 className={Style.section_title}>{t("plan_details") || "Plan Details"}</h3>

      <div className={Style.row}>
        <label>{t("coverage_type")}<span className="star">*</span></label>
        <div>
          <Select
            options={coverageTypes}
            value={coverageTypes.find(opt => opt.value === coverageType)}
            onChange={(e) => {
              setCoverageType(e.value);
              setSelectedStates([]);
              setSelectedDistricts({});
            }}
            required
          />
        </div>
      </div>

      {coverageType === 'state' && (
        <>
          <div className={Style.row}>
            <label>{t("select_states")}<span className="star">*</span></label>
            <div className={Style.selection_list}>
              {STATES_DISTRICTS_DATA.states.map((stateObj, index) => (
                <div
                  key={index}
                  className={Style.selection_item}
                  onClick={() => toggleStateSelection(stateObj.state)}
                >
                  <span>{stateObj.state}</span>
                  <input
                    type="checkbox"
                    checked={selectedStates.includes(stateObj.state)}
                    readOnly
                  />
                </div>
              ))}
            </div>
          </div>

          {selectedStates.map((stateName) => {
            const stateObj = STATES_DISTRICTS_DATA.states.find(s => s.state === stateName);
            const districts = stateObj?.districts || [];

            return (
              <div key={stateName} className={Style.row}>
                <label>
                  {t("select_districts_in")} {stateName}<span className="star">*</span>
                </label>
                <div className={Style.selection_list}>
                  {districts.map((districtName, index) => (
                    <div
                      key={`${stateName}-${index}`}
                      className={Style.selection_item}
                      onClick={() => toggleDistrictSelection(stateName, districtName)}
                    >
                      <span>{districtName}</span>
                      <input
                        type="checkbox"
                        checked={selectedDistricts[stateName]?.includes(districtName)}
                        readOnly
                      />
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </>
      )}

      <div className={Style.row}>
        <label>{t("num_days")}<span className="star">*</span></label>
        <div className={Style.items}>
          <input
            type="number"
            min="1"
            value={numDays}
            onChange={(e) => setNumDays(e.target.value)}
            placeholder={t("enter_days") || "Enter number of days"}
            required
          />
        </div>
      </div>

      <div className={Style.row}>
        <label>{t("display_page") || "Display Page"}</label>
        <div className={Style.page_toggle_container}>
          {pageOptions.map((page) => (
            <button
              key={page.value}
              type="button"
              className={`${Style.page_toggle} ${
                (renderHomeToggle && page.value === 'home') ||
                (!renderHomeToggle && selectedPage === page.value)
                  ? Style.page_toggle_active
                  : ''
              }`}
              onClick={() => {
                if (page.value === 'home') {
                  setRenderHomeToggle(true);
                  setSelectedPage('home');
                } else {
                  setRenderHomeToggle(false);
                  setSelectedPage(page.value);
                }
              }}
            >
              {page.label}
            </button>
          ))}
        </div>
      </div>

      {selectedPage === 'category' && !renderHomeToggle && (
        <div className={Style.row}>
          <label>{t("category")}<span className="star">*</span></label>
          <div>
            <Select
              options={[{ value: "", label: t("select_category") || "Select Category" }, ...CatSelecter]}
              value={CatSelecter.find(cat => cat.value === selectedCategory) || null}
              onChange={(e) => setSelectedCategory(e.value)}
              required
            />
          </div>
        </div>
      )}

      <div className={Style.price_info}>
        <span>{t("estimated_price") || "Estimated Price"}:</span>
        <strong>₹{price}</strong>
      </div>
    </div>
  );

  // Section 3: Summary & Payment
  const renderSection3 = () => (
    <div className={Style.section}>
      <h3 className={Style.section_title}>{t("summary") || "Payment & Confirmation"}</h3>

      <div className={Style.summary_card}>
        <h4>{t("ad_summary") || "Advertisement Summary"}</h4>

        <div className={Style.summary_row}>
          <span>{t("title")}:</span>
          <span>{ProductData.title}</span>
        </div>

        <div className={Style.summary_row}>
          <span>{t("advertisement_size")}:</span>
          <span>{sizeOptions.find(s => s.value === ProductData.advSize)?.label}</span>
        </div>

        <div className={Style.summary_row}>
          <span>{t("coverage")}:</span>
          <span>{coverageType.charAt(0).toUpperCase() + coverageType.slice(1)}</span>
        </div>

        {coverageType === 'state' && selectedStates.length > 0 && (
          <>
            <div className={Style.summary_row}>
              <span>{t("states")}:</span>
              <span>{selectedStates.length} state(s)</span>
            </div>
            <div className={Style.summary_row}>
              <span>{t("districts")}:</span>
              <span>
                {Object.values(selectedDistricts).reduce((sum, arr) => sum + arr.length, 0)} district(s)
              </span>
            </div>
          </>
        )}

        <div className={Style.summary_row}>
          <span>{t("duration")}:</span>
          <span>{numDays} day(s)</span>
        </div>

        <div className={Style.summary_row}>
          <span>{t("display_page")}:</span>
          <span>{getPageLabel()}</span>
        </div>

        {selectedPage === 'category' && !renderHomeToggle && selectedCategory && (
          <div className={Style.summary_row}>
            <span>{t("category")}:</span>
            <span>{getCategoryName(selectedCategory)}</span>
          </div>
        )}

        <div className={`${Style.summary_row} ${Style.total_row}`}>
          <span><strong>{t("total_amount")}:</strong></span>
          <span><strong>₹{price}</strong></span>
        </div>
      </div>
    </div>
  );

  return (
    <div className={Style.Main_Container}>
      <div className={Style.Container_Wrapper}>
        {/* Progress Bar */}
        <div className={Style.progress_bar}>
          {[1, 2, 3].map((step) => (
            <div
              key={step}
              className={`${Style.progress_step} ${
                currentSection >= step ? Style.progress_step_active : ''
              }`}
            >
              <span>{step}</span>
            </div>
          ))}
        </div>

        <form onSubmit={(e) => e.preventDefault()}>
          {currentSection === 1 && renderSection1()}
          {currentSection === 2 && renderSection2()}
          {currentSection === 3 && renderSection3()}

          {/* Navigation Buttons */}
          <div className={Style.submit_section}>
            {currentSection > 1 && (
              <button
                type="button"
                className={Style.back_button}
                onClick={handleBack}
              >
                {t("back") || "Back"}
              </button>
            )}

            {currentSection < 3 ? (
              <button
                type="button"
                className={Style.next_button}
                onClick={handleNext}
              >
                {t("next") || "Next"}
              </button>
            ) : (
              <button
                type="button"
                className={Style.pay_button}
                onClick={handlePayment}
                disabled={loading}
              >
                {loading ? (
                  <LoadingSpin size="20px" direction="alternate" width="4px" />
                ) : (
                  `${t("pay") || "Pay"} ₹${price}`
                )}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdvertisementForm;